import React from 'react';

import Button from '../../../components/Buttons/Button';
import ButtonSec from '../../../components/Buttons/ButtonSecundary';
import { useScreenSize } from '../../../hooks/useScreenSize';
import { useNavigate } from 'react-router';

const Service: React.FC = () => {
  const { isTablet } = useScreenSize();
  const navigate = useNavigate();

  return (
    <section className="slide flex-colomn gap-2">
      <div className="flex-colomn ">
        <h2>
          <span className="tertiary-color ">Installatie</span> & onderhoud.
        </h2>
        <div className={` ${isTablet ? ' flex-colomn gap-2' : 'flex-row gap-5 space-between'}`}>
          <div className="flex-colomn w-100">
            <p>
              <span className="bold">Professionele installatie:</span> Energiezuinige airco’s voor
              woningen en bedrijven.
            </p>
            <p>
              <span className="bold">Onderhoud & nazorg:</span> Voor een blijvend efficiënt en stil
              werkend systeem.
            </p>
          </div>
          <div className={`flex-row align-end w-100`}>
            <div className="flex-colomn w-100">
              <Button
                onClick={() => navigate('/', { state: { slide: 5 } })}
                text="Contacteer ons!"
              />
              <ButtonSec to={'/installatie-voorbeelden'} text="Bekijk onze catalogus" />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Service;
